import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import * as ajax from '@/request'
import VueClipboard from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/index.css';
import qs from 'qs'

Vue.use(ElementUI);
Vue.use(VueClipboard)
Vue.prototype.$http = ajax
Vue.prototype.bus = new Vue();
Vue.config.productionTip = false

router.beforeEach(async (to, from, next) => {
  next()
  if (to.path === '/resource') {
    // 对访问数据时，进行历史记录
    // 发送请求 保存到数据库 d src
    const data = {'src': to.fullPath, 'd': to.query.code}
    Vue.prototype.$http.postAddUserOperation(qs.stringify(data)).then(res => {
    }).catch(err => {
    })
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#project')
